export default __webpack_public_path__ + "static/media/super_sports.401d72bd.png";